// extracted by mini-css-extract-plugin
export default {"container":"MobileDrawer_container__kjlx2","close":"MobileDrawer_close__OxP8I","shadow":"MobileDrawer_shadow__t2RNr"};